// global.js: sitewide behaviour (Clarity loader, card colour-swap preload, scroll
// animations, blur-up, sticky header, mega-menu backgrounds, currency notice).
// Extracted from layout/theme.liquid inline blocks so browsers cache it across pages.

(function () {
    var CLARITY_ID = 'x5lsjnbp54';
    var started = false;
    function startClarity() {
      if (started) return; started = true;
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', CLARITY_ID);
      try { window.clarity('consent'); } catch (e) {}
    }
    function analyticsOk() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      try {
        if (typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
        if (typeof cp.userCanBeTracked === 'function') return cp.userCanBeTracked();
      } catch (e) {}
      return false;
    }
    // Speed (2026-10-02): Clarity starts once the page has finished loading and the browser is
    // idle (at most 3 s later), so its script never competes with the page's own photos and code.
    // Consent gating is unchanged. Recordings still cover the whole visit from that point.
    // On a slow connection the load event can take 10 s or more, so Clarity also starts 4 s after
    // this point at the latest; otherwise visits that leave early would never be recorded at all.
    // startClarity() runs once, whichever comes first.
    function whenLoaded(fn) {
      var idle = function () { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 1500); };
      if (document.readyState === 'complete') idle(); else { window.addEventListener('load', idle); setTimeout(fn, 4000); }
    }
    document.addEventListener('visitorConsentCollected', function (e) {
      if ((e && e.detail && e.detail.analyticsAllowed) || analyticsOk()) whenLoaded(startClarity);
    });
    function checkExisting() { if (analyticsOk()) whenLoaded(startClarity); }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { checkExisting(); });
    } else if (document.readyState !== 'loading') { checkExisting(); }
    else { document.addEventListener('DOMContentLoaded', checkExisting); }
  })();

(function () {
    // Preload a card's other-colour images the moment the shopper hovers/touches it,
    // so clicking a swatch swaps the photo INSTANTLY (no fetch lag). Runs once per card.
    function preloadCard(card) {
      if (!card || card.__pcPre) return; card.__pcPre = true;
      // The active colour is the photo already on the card, so it is not fetched a second time.
      card.querySelectorAll('.pc-swatch[data-pc-img]:not(.is-active)').forEach(function (s) { var i = new Image(); i.src = s.dataset.pcImg; });
    }
    document.addEventListener('pointerover', function (e) { var c = e.target.closest && e.target.closest('.product-card'); if (c) preloadCard(c); }, { passive: true });
    document.addEventListener('touchstart', function (e) { var c = e.target.closest && e.target.closest('.product-card'); if (c) preloadCard(c); }, { passive: true });

    // Speed (2026-10-02): colour photos are no longer fetched for every card near the viewport
    // after load. That pulled about 6 extra photos per category or search page, most of them
    // never looked at. Hover (desktop) and touch (phone) above still fetch a card's colours the
    // moment the shopper reaches for it, so a swatch tap still swaps almost at once.

    document.addEventListener('click', function (e) {
      var b = e.target.closest('.pc-swatch'); if (!b) return;
      e.preventDefault();
      var card = b.closest('.product-card'); if (!card) return;
      var img = card.querySelector('[data-pc-main]');
      if (img && b.dataset.pcImg && img.src !== b.dataset.pcImg) {
        var want = b.dataset.pcImg; card.__pcWant = want;
        var swap = function () {
          if (card.__pcWant !== want) return; // a later tap on another colour wins
          img.removeAttribute('srcset'); img.src = want; img.classList.remove('is-swapping');
        };
        if (!img.complete) {
          // Photo not shown yet (lazy, below the screen, or still arriving): point it at the chosen
          // colour so only that photo downloads, when it is needed.
          swap();
        } else {
          var pre = new Image();
          pre.onload = pre.onerror = swap;
          pre.src = want;
          // Preloaded on hover or touch: a quick fade. Still downloading: the current photo stays
          // on screen until the new one has arrived, so the card never shows a blank frame.
          img.classList.toggle('is-swapping', pre.complete);
        }
      }
      var cur = card.querySelector('[data-pc-current]'), cmp = card.querySelector('[data-pc-compare]'), sav = card.querySelector('[data-pc-save]'), sale = card.querySelector('[data-pc-sale]');
      if (cur && b.dataset.pcPrice) cur.textContent = b.dataset.pcPrice;
      if (b.dataset.pcCompare) {
        if (cmp) { cmp.textContent = b.dataset.pcCompare; cmp.hidden = false; }
        if (sav) { sav.textContent = b.dataset.pcSave; sav.hidden = false; }
        if (sale) sale.hidden = false;            // chosen variant is on sale → show the badge
      } else { if (cmp) cmp.hidden = true; if (sav) sav.hidden = true; if (sale) sale.hidden = true; }
      card.querySelectorAll('.pc-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      b.classList.add('is-active');
      // Keep the card's links pointing at the chosen colour, so clicking through lands on
      // the product page with that variant pre-selected.
      if (b.dataset.pcVariant) {
        card.querySelectorAll('[data-pc-link]').forEach(function (a) {
          var base = (a.getAttribute('href') || '').split('?')[0];
          a.setAttribute('href', base + '?variant=' + b.dataset.pcVariant);
        });
      }
    });

    // Auto-select the filtered colour on every card. Reads the active colour bucket
    // straight from the URL — the collection tag path (/collections/x/colour_pink) or
    // the search param (?filter.p.tag=Colour_Pink) — so it works regardless of whether
    // Liquid could resolve it server-side. Each swatch carries data-bucket (canonical),
    // so we match by bucket and reuse the swap above. Skips cards already on that colour.
    function activeColourBucket() {
      var m = location.pathname.match(/colou?r[_-]([a-z0-9]+)/i);
      if (m) return m[1].toLowerCase();
      try {
        var tags = new URLSearchParams(location.search).getAll('filter.p.tag');
        for (var i = 0; i < tags.length; i++) {
          var mm = String(tags[i]).match(/colou?r[_-]([a-z0-9]+)/i);
          if (mm) return mm[1].toLowerCase();
        }
      } catch (e) {}
      return '';
    }
    function autoSelectColour(root) {
      var want = activeColourBucket(); if (!want) return;
      (root || document).querySelectorAll('.product-card').forEach(function (card) {
        if (card.__pcAuto) return; card.__pcAuto = 1;
        var match = null;
        card.querySelectorAll('.pc-swatch[data-bucket]').forEach(function (s) {
          if (!match && (s.dataset.bucket || '').toLowerCase() === want) match = s;
        });
        if (match && !match.classList.contains('is-active')) match.click();
      });
    }
    if (document.readyState !== 'loading') autoSelectColour(); else document.addEventListener('DOMContentLoaded', function () { autoSelectColour(); });
    document.addEventListener('shopify:section:load', function (e) { autoSelectColour(e.target); });
  })();

(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    // 1) Scroll-reveal — homepage sections gently fade/slide up as they enter view.
    if (hasIO && !reduce && document.body.classList.contains('template-index')) {
      var secs = [].slice.call(document.querySelectorAll('.main-content .shopify-section'));
      secs.forEach(function (s, i) { if (i > 0) s.classList.add('reveal-el'); });
      // Anything already on-screen at load is marked revealed up-front (no flash).
      secs.forEach(function (s) { if (s.getBoundingClientRect().top < window.innerHeight * 0.92) s.classList.add('is-in'); });
      document.body.classList.add('reveal-on');
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px' });
      secs.forEach(function (s) { if (s.classList.contains('reveal-el') && !s.classList.contains('is-in')) rio.observe(s); });
    }

    // 2) Count-up — animate numbers (ratings, review counts) when scrolled into view.
    if (hasIO && !reduce) {
      var run = function (el) {
        var full = (el.getAttribute('data-countup') || el.textContent || '').trim();
        var m = full.match(/([\d,]+(?:\.\d+)?)/); if (!m) return;
        var numStr = m[1].replace(/,/g, ''), target = parseFloat(numStr);
        var dec = numStr.indexOf('.') >= 0 ? 1 : 0;
        var pre = full.slice(0, m.index), suf = full.slice(m.index + m[1].length), start = null;
        // Lock the element to its final rendered width (it is server-rendered at the
        // final value) so counting up never reflows neighbouring text, and left-pad the
        // number with figure-spaces to a constant length so the suffix doesn't slide.
        var lockW = el.getBoundingClientRect().width;
        el.style.display = 'inline-block'; el.style.minWidth = lockW + 'px';
        var padTo = (dec ? target.toFixed(1) : Math.round(target).toLocaleString('en')).length;
        var fmt = function (n) { var sNum = dec ? n.toFixed(1) : Math.round(n).toLocaleString('en'); while (sNum.length < padTo) { sNum = ' ' + sNum; } return pre + sNum + suf; };
        var step = function (ts) { if (!start) start = ts; var p = Math.min(1, (ts - start) / 2400); var eased = 1 - Math.pow(1 - p, 3); el.textContent = fmt((0.85 + 0.15 * eased) * target); if (p < 1) requestAnimationFrame(step); else el.textContent = full; };
        requestAnimationFrame(step);
      };
      var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
      document.querySelectorAll('[data-countup]').forEach(function (el) { cio.observe(el); });
    }
  })();

(function () {
    // Blur-up: images fade in when they finish loading; a shimmer fills the frame
    // meanwhile. The .blurup class is added by JS only, so no-JS users always see images.
    // Speed (2026-10-03): the shimmer is a background-position animation, which the browser repaints on the main
    // thread every frame for every waiting card, including the 15-24 cards below the screen whose lazy photos have
    // not started (64-82% of a slow phone's idle main-thread time on home/collection/search). base.css now keeps it
    // paused, and this observer runs it only while the frame is on screen (.media-vis), with the start offset taken
    // from one shared clock so every card shimmers in step as before. Looks the same.
    // Undo: delete shimIO and its 3 uses below, and the 2 "Speed (2026-10-03)" .media-loading rules in base.css.
    var shimIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { var f = e.target; if (e.isIntersecting) { f.style.setProperty('--shim-d', -(performance.now() % 1200) + 'ms'); f.classList.add('media-vis'); } else f.classList.remove('media-vis'); });
    }, { rootMargin: '200px 0px' }) : null;
    function blurUp(img) {
      if (!img || img.dataset.bu) return; img.dataset.bu = '1';
      if (img.complete && img.naturalWidth) return; // already loaded (cached) → leave as-is
      img.classList.add('blurup');
      var frame = img.closest('.product-card__media, .product-gallery__main') || img.parentNode;
      if (frame) { frame.classList.add('media-loading'); if (shimIO) shimIO.observe(frame); else frame.classList.add('media-vis'); }
      var done = function () { img.classList.add('is-loaded'); if (frame) { frame.classList.remove('media-loading'); if (shimIO) shimIO.unobserve(frame); } };
      img.addEventListener('load', done); img.addEventListener('error', done);
      if (img.complete && img.naturalWidth) done(); // raced to load between checks
    }
    function scan() { document.querySelectorAll('.product-card__img, #main-product-img').forEach(blurUp); }
    if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);

    // Condensed sticky header: shrink padding + logo and add a shadow once scrolled.
    var header = document.querySelector('.header');
    if (header) {
      var ticking = false;
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { header.classList.toggle('is-scrolled', window.scrollY > 80); ticking = false; });
      }
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  })();

(function () {
    function setBg(el) { if (el && el.dataset.bg) { el.style.backgroundImage = "url('" + el.dataset.bg + "')"; el.removeAttribute('data-bg'); } }
    function fill(scope) { (scope || document).querySelectorAll('.mega-life[data-bg]').forEach(setBg); }
    function onItem(e) { var it = e.target.closest && e.target.closest('.mega-item'); if (it) fill(it); }
    document.addEventListener('pointerover', onItem, { passive: true });
    document.addEventListener('focusin', onItem);
    document.addEventListener('click', onItem, { passive: true }); // mobile accordion taps
  })();

(function () {
    var c = window.Shopify && Shopify.currency;
    if (!c || c.active === 'EUR') return;
    var sym = { GBP: '£', USD: '$', EUR: '€' }[c.active];
    if (!sym) return;
    document.querySelectorAll('[data-promo]').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/€\s?([\d,]+)/g, function (_, n) { return sym + n; });
    });
  })();

